import React, { useEffect, useState } from "react";
import "normalize.css";

import config from "./utils/config";

import Amplify, { Auth } from "aws-amplify";
import { Hub, HubCallback } from "@aws-amplify/core";
import { Authenticator } from "@aws-amplify/ui-react";
import {
	UI_AUTH_CHANNEL,
	TOAST_AUTH_ERROR_EVENT,
} from "@aws-amplify/ui-components";

import { Client as Styletron } from "styletron-engine-atomic";
import { Provider as StyletronProvider } from "styletron-react";
import { LightTheme, BaseProvider, createTheme } from "baseui";

import styled, { ThemeProvider } from "styled-components";
import theme from "./utils/theme";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";

// TODO apply to config
Amplify.configure(config.AMPLIFY);

const engine = new Styletron();

const Logo = styled.img`
	object-fit: contain;
	display: block;
	height: 3rem;
	width: 100%;
	margin-bottom: 1.5rem;
`;

const Tip = styled.div`
	margin-top: 1.5rem;
	background-color: #2b9f57;
	color: #fff;
	font-weight: bold;
	padding: 2rem;
	box-sizing: border-box;
	border-radius: 0.5rem;
`;

const Error = styled.div`
	margin-top: 1.5rem;
	background-color: red;
	color: #fff;
	font-weight: bold;
	padding: 2rem;
	box-sizing: border-box;
`;

const AppContainer = (props: any) => {
	let [authUser, setAuthUser] = useState(null);
	const [authErrorMessage, setAuthErrorMessage] = useState("");

	const handleAuthErrors: HubCallback = ({ payload }: any) => {
		if (payload.event === TOAST_AUTH_ERROR_EVENT && payload.message) {
			setAuthErrorMessage(payload.message);
		}
	};

	useEffect(() => {
		let updateAuthUser = async () => {
			try {
				let user = await Auth.currentAuthenticatedUser();
				setAuthUser(user);

				let creds = (await Auth.currentSession()) as any;
				if (config.LOG_REQUESTS) {
					console.log(creds);
				}
			} catch {
				setAuthUser(null);
			}
		};
		Hub.listen("auth", updateAuthUser); // listen for login/signup events
		Hub.listen(UI_AUTH_CHANNEL, handleAuthErrors);

		// we are not using async to wait for updateUser, so there will be a flash of page where the user is assumed not to be logged in. If we use a flag
		updateAuthUser(); // check manually the first time because we won't get a Hub event
		return () => Hub.remove("auth", updateAuthUser); // cleanup
	}, []);

	const authServices = {
		handleSignIn: async (formData: any) => {
			return Auth.signIn({
				username: formData.username.trim(),
				password: formData.password.trim(),
			});
		},
	};

	return (
		<>
			<StyletronProvider value={engine}>
				<ThemeProvider theme={theme}>
					<BaseProvider theme={LightTheme}>
						{authUser == null ? (
							<>
								<Logo src="/assets/ppcs.svg" />
								<Authenticator
									services={authServices}
									components={{}}
									hideSignUp={true}
								/>
							</>
						) : (
							<>{props.children}</>
						)}
					</BaseProvider>
				</ThemeProvider>
			</StyletronProvider>
			<ToastContainer />
		</>
	);
};
export default AppContainer;
